export const differentials = [
  {
    title: "Metodologia comprovada",
    paragraph:
      "Aulas online para que você estude em horários flexíveis de acordo com a sua rotina. A maneira que ensinamos, as ferramentas, a comunicação e os projetos simulam o dia a dia de uma empresa de tecnologia.",
    image: "/images/icon-approve.svg",
  },
  {
    title: "Conteúdo sempre atualizado",
    paragraph:
      "A cada 3 meses, nós adaptamos e melhoramos nosso material de ensino, conforme as atualizações exigidas pelo mercado e, também, através dos feedbacks recebidos dos nossos alunos.",
    image: "/images/icon-check.svg",
  },
  {
    title: "Desenvolvimento de Soft Skills",
    paragraph:
      "Aprenda skills que vão além de questões técnicas, como gestão de tempo, organização, comunicação clara, disciplina, pensamento crítico, autonomia, perseverança e aprender com os erros.",
    image: "/images/icon-develop.svg",
  },
  {
    title: "Aprenda na prática",
    paragraph:
      "Aqui, você aprende desenvolvendo projetos para a resolução de problemas diariamente, muito semelhantes aos encontrados no dia a dia de um desenvolvedor.",
    image: "/images/icon-monitor.svg",
  },
  {
    title: "Contato com o mercado",
    paragraph:
      "A cada 2 semanas, promovemos eventos com especialistas de mercado para compartilhar a vivência deles em diversas áreas e trazer diferentes perspectivas para os nossos alunos.",
    image: "/images/icon-rocket.svg",
  },
  {
    title: "Mentoria de carreira",
    paragraph:
      "Conte com o apoio de mentores para te ajudar tanto com temas técnicos e quanto com habilidades interpessoais, contribuindo para o desenvolvimento da sua carreira profissional.",
    image: "/images/icon-meet.svg",
  },
];
